import React from 'react';
import PropTypes from 'prop-types';
import { Popup, Loader } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import {
  ToggleSwitchTrack,
  ToggleSwitchThumb,
  ToggleSwitchLabel,
  ToggleSwitchWrapper,
  LoadingIndicator,
  LoadingText
} from './styled';

const CouplingToggle = ({
  enabled,
  fetchingAlarms,
  onToggle,
  statusTooltip,
  disabled,
  disabledReason,
  labelKey,
  toggleHelpKey
}) => {
  const { t } = useTranslation();
  const handleClick = (e) => {
    if (disabled || fetchingAlarms) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    onToggle();
  };

  const isDisabled = fetchingAlarms || disabled;

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <Popup
        trigger={(
          <ToggleSwitchWrapper onClick={handleClick} disabled={isDisabled}>
            <ToggleSwitchTrack checked={enabled} disabled={isDisabled}>
              <ToggleSwitchThumb checked={enabled} />
            </ToggleSwitchTrack>
            <ToggleSwitchLabel checked={enabled}>
            {t(labelKey || 'sensors.eventDetection.coupling.coupleWithAlarmThresholds')}
            </ToggleSwitchLabel>
            {fetchingAlarms && (
              <LoadingIndicator>
                <Loader active inline size="tiny" />
              <LoadingText>{t('sensors.eventDetection.coupling.loadingThresholds')}</LoadingText>
              </LoadingIndicator>
            )}
          </ToggleSwitchWrapper>
        )}
        content={
          disabled && disabledReason
            ? disabledReason
            : t(toggleHelpKey || 'sensors.eventDetection.coupling.toggleHelp')
        }
        position="bottom left"
        size="small"
        disabled={fetchingAlarms}
      />
      {statusTooltip}
    </div>
  );
};

CouplingToggle.propTypes = {
  enabled: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  disabledReason: PropTypes.string,
  fetchingAlarms: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
  statusTooltip: PropTypes.node,
  labelKey: PropTypes.string,
  toggleHelpKey: PropTypes.string
};

CouplingToggle.defaultProps = {
  fetchingAlarms: false,
  statusTooltip: null,
  disabledReason: null,
  labelKey: 'sensors.eventDetection.coupling.coupleWithAlarmThresholds',
  toggleHelpKey: null
};

// Memoized because props are stable (primitives and useCallback function)
export default React.memo(CouplingToggle);
